import { render, staticRenderFns } from "./ViewMerchantBusiness.vue?vue&type=template&id=a9abd0f6&scoped=true"
import script from "./ViewMerchantBusiness.vue?vue&type=script&lang=js"
export * from "./ViewMerchantBusiness.vue?vue&type=script&lang=js"
import style0 from "./ViewMerchantBusiness.vue?vue&type=style&index=0&id=a9abd0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9abd0f6",
  null
  
)

export default component.exports